import s from "./index2.js";
import { resolveComponent as r, openBlock as i, createBlock as c, withCtx as o, createVNode as m, createElementVNode as d, toDisplayString as t, createTextVNode as n, createCommentVNode as l } from "vue";
import u from "../../../../_virtual/index.js";
function y(e, b, f, g, C, N) {
  const a = r("i18n-t"), p = r("BasePrompt");
  return e.isVisible && e.areTranslationsLoaded ? (i(), c(p, {
    key: 0,
    id: "ip-redirect-prompt",
    class: "redirect-prompt",
    yesAction: e.changeCountryLink,
    noAction: e.dontChangeCountryLink
  }, {
    "base-prompt-question": o(() => [
      m(a, {
        keypath: "@ado/base-application.redirect-prompt.your-country-is-set-to",
        tag: "span",
        class: "redirect-prompt-current-country",
        scope: "global"
      }, {
        countryName: o(() => [
          d("strong", null, t(e.t("countries." + e.currentCountryName)), 1)
        ]),
        _: 1
      })
    ]),
    "base-prompt-yes-label": o(() => [
      n(t(e.t("redirect-prompt.change-to", { countryName: e.t(e.newCountryName()) })), 1)
    ]),
    "base-prompt-no-label": o(() => [
      n(t(e.t("redirect-prompt.dont-change")), 1)
    ]),
    _: 1
  }, 8, ["yesAction", "noAction"])) : l("", !0);
}
const _ = /* @__PURE__ */ u(s, [["render", y]]);
export {
  _ as default
};
//# sourceMappingURL=index.js.map
